export const API_TYPES = {
  COMPANIES: "COMPANIES",
  CONTACTS: "CONTACTS",
  INVENTORY: "INVENTORY",
  DEFAULT: "DEFAULT",
};
